import {
  TrainingMaterialApiRequest,
  UpdateTrainingMaterialRequest,
} from '@/data/payload/api/TrainingMaterialRequest'
import {
  PostTrainingMaterialInterface,
  DeleteTrainingMaterialInterface,
  UpdateTrainingMaterialInterface,
} from '@/data/payload/contracts/TrainingMaterialRequest'
import ApiService from '@/app/framework/services/ApiServices'
import { TrainingMaterialDataMapper } from '@/data/persistences/mappers/TrainingMaterialDataMapper'
import { TrainingMaterialRepositoryInterface } from '@/data/persistences/repositories/contracts/TrainingMaterialRepositoryInterface'
import { TrainingMaterial } from '@/domain/entities/TrainingMaterial'
import { Endpoints } from '@/app/framework/misc/Endpoints'

export class TrainingMaterialApiRepository
  implements TrainingMaterialRepositoryInterface {
  private service: ApiService
  private mapper: TrainingMaterialDataMapper

  constructor(service: ApiService, mapper: TrainingMaterialDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async delete(
    payload: DeleteTrainingMaterialInterface
  ): Promise<TrainingMaterial> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.TRAINING_MATERIAL_DELETE,
      undefined,
      payload as TrainingMaterialApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async post(
    payload: PostTrainingMaterialInterface
  ): Promise<TrainingMaterial> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.TRAINING_MATERIAL,
      undefined,
      payload as TrainingMaterialApiRequest,
      undefined,
      'form-data'
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async update(
    payload: UpdateTrainingMaterialInterface,
    id: number
  ): Promise<TrainingMaterial> {
    const resp = await this.service.invoke(
      'post',
      `${Endpoints.Route.TRAINING_MATERIAL}/${id}`,
      undefined,
      payload as UpdateTrainingMaterialRequest,
      undefined,
      'form-data'
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async getAll(params: Object): Promise<TrainingMaterial> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.TRAINING_MATERIAL,
      params
    )
    return this.mapper.convertFromApi(resp)
  }
}
